import { Component, OnInit, ElementRef, ViewChild, OnDestroy, Input, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import * as RolesRouteMap from '../../../data/constants/roles';
import { Router } from '@angular/router';
import moment from 'moment';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DashboardWidgetsService } from 'src/app/services/dashboard-widgets.service';
import { ReferenceLibrary } from 'src/app/data/models/referenceLibrary.model';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, map, filter, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as Task from 'src/app/modules/superTask/task-state/actions/task.actions';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ImagilityBaseResponse } from 'app-models';
import { ToastrService } from 'ngx-toastr';
import { CustomErrorToastComponent } from 'custom-error-toast';
import { ReferenceLibraryService } from 'reference-library';

export interface petitionDisplaylist {
  status: string;
  beneName: string;
  petitionTypeName: string;
  company: string;
  dateFiled: string;
  action: string;
}

@Component({
  selector: 'app-manage-petition-bene',
  templateUrl: './manage-petition-bene.component.html',
  styleUrls: ['./manage-petition-bene.component.scss']
})

export class ManagePetitionBeneComponent implements OnInit, OnDestroy, AfterViewInit {

  taskList = [];
  companyType: string;
  companyId;
  petitionCount: any;
  newPetitionCount: number;
  newPetitionCompanyName: any;
  // selectBoxactions: any[];
  petitionData: Array<petitionDisplaylist> = [];
  dataSource;

  selSubTaskFilterCtg: number[] = [];
  selectAllSubTask = true;
  taskType: ReferenceLibrary[];
  subTaskType: ReferenceLibrary[];
  visaTypes: ReferenceLibrary[];
  petitionTypes: ReferenceLibrary[];
  cols: any[];
  nestedCols: any[];
  immigrantTypeCols: any[];
  nonImmigrantTypeCols: any[];
  immigrantTypeNestedCols: any[];
  nonImmigrantTypeNestedCols: any[];
  toggleStatus;
  totalElementCount = 0;
  pageSizeOptions = [25, 50, 100];
  pageIndex = 1; // default
  pageSize = 25; // default
  searchText = '';
  completedSuperTaskCount = 0;
  activeRecordCount = 0;
  showFilter = false;
  isOutsideImagility = false;

  filter = {
    superTaskType: 'NONIMMPET',
    subTaskType: [],
    visaType: [],
    petitionType: []
  };

  payload = {
    companyId: parseInt(sessionStorage.getItem('companyId')),
    endDate: null,
    pageNumber: this.pageIndex,
    pageSize: null,
    searchText: this.searchText,
    startDate: null,
    visaTypes: [],
    petitionTypes: [],
    subTaskTypes: [],
    superTaskType: '',
    taskStatus: [],
  };

  searchSubscription: Subscription;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("searchBeneficiaryListTable", { static: true }) searchBeneficiaryListTable: ElementRef;
  // filteredSuntaskType: string[];
  @Input() individualId: any;
  @Input() isFromListingPage: boolean = false;
  userType: string;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private referenceLibraryService: ReferenceLibraryService,
    private dashboardWidgetsService: DashboardWidgetsService,
    protected store: Store<any>,
    private toastr: ToastrService,
    public dialog: MatDialog) {
    this.newPetitionCompanyName = "";
  }

  ngOnInit() {
    this.userType = sessionStorage.getItem('userTypeRole');
    this.immigrantTypeCols = [
      { field: 'status', header: 'STATUS' },
      { field: 'beneficiaryName', header: 'BENEFICIARY NAME' },
      { field: 'companyName', header: 'COMPANY NAME' },
      { field: 'immCategory', header: 'IMMIGRATION CATEGORY' },
      { field: 'immClassification', header: 'IMMIGRATION CLASSIFICATION' },
      { field: 'startDate', header: 'DATE CREATED' },
    ];
    this.nonImmigrantTypeCols = [
      { field: 'status', header: 'STATUS' },
      { field: 'beneficiaryName', header: 'BENEFICIARY NAME' },
      { field: 'companyName', header: 'COMPANY NAME' },
      { field: 'visaType', header: 'VISA TYPE' },
      { field: 'petitionType', header: 'PETITION TYPE' },
      { field: 'startDate', header: 'DATE CREATED' },
    ];
    //this.authenticationService.currentUser.subscribe((data) => {
      // let loggedInBeneficiaryId = sessionStorage.getItem('loggedInBeneficiaryId');
      this.getTaskType();
      this.searchSetUp();
    //});
    this.translet();
  }

  getTaskType() {
    this.referenceLibraryService.getReferenceData('SUPTSKTYP')
      .pipe(take(1))
      .subscribe((response: ReferenceLibrary[]) => {
        // this.taskType = this.referenceLibraryService.translateArray(response, 'name');
        this.referenceLibraryService.translateArray(response, 'name')
        .then(translated => {
          this.taskType = translated;
        })
        .catch(error => console.error("Translation error:", error));

        this.getSubTaskType();
        this.cols = this.nonImmigrantTypeCols;
        this.nestedCols = this.nonImmigrantTypeNestedCols;
      });
  }

  getSubTaskType() {
    // this.filter.superTaskType = superTaskType;
    this.cols = this.filter.superTaskType === 'NONIMMPET' ? this.nonImmigrantTypeCols : this.immigrantTypeCols;
    this.nestedCols = this.filter.superTaskType === 'NONIMMPET' ? this.nonImmigrantTypeNestedCols : this.immigrantTypeNestedCols;
    // console.log(this.filter.superTaskType);
    // this.dashboardWidgetsService.getSubTasksType(this.filter.superTaskType).subscribe((response: ReferenceLibrary[]) => {
    //   this.subTaskType = response;
    //   response.forEach(x => {
    //     this.filter.subTaskType.push(x.code);
    //   });
    //   // this.filteredSuntaskType = response.map(x => x.code);
    //   // if (this.taskList.length > 0) {
    //   //   this.setFilteredTaskList();
    //   // }
    // });
    this.loadBeneficiaryPetitions();
  }

  loadBeneficiaryPetitions() {
    this.payload.superTaskType = this.filter.superTaskType;
    const beneficiaryId = this.individualId || sessionStorage.getItem('beneficiaryId');
    if (beneficiaryId) {
      this.dashboardWidgetsService.getTaskListForBeneficiary(beneficiaryId, this.payload)
        .pipe(take(1))
        .subscribe(data => {
          if (data && data.superTasks) {
            this.taskList = data.superTasks;
            // this.setDisplayData(this.taskList);
            // this.getSubTaskType();
          } else {
            this.taskList = [];
            // this.dataSource = new MatTableDataSource([]);
            // this.dataSource.sort = this.sort;
          }
        });
    }
  }

  // setFilteredTaskList() {
  //   // this.filteredTaskList = this.taskList.filter()
  // }

  setDisplayData(response) {
    let newPetitionCount = 0;
    if (response.totalNumberOfPetitions != undefined) {
      this.petitionCount = response.totalNumberOfPetitions;
    }
    response.petitionsList.forEach((element, index) => {
      element.createdDate = moment(element.createdDate).format('MM/DD/YYYY');
      if (element.mostRecentPetition) {
        this.newPetitionCount = ++newPetitionCount;
        this.newPetitionCompanyName = element.companyname;
      }
      this.petitionData.push(
        {
          status: element.petitionStatusString,
          beneName: element.beneficiaryName,
          petitionTypeName: element.petitionType.name,
          company: element.companyname,
          dateFiled: element.createdDate,
          action: element.taskId
        });
    });
    this.dataSource = new MatTableDataSource(this.petitionData);
    this.dataSource.sort = this.sort;
  }

  handleTask(task: any) {
    sessionStorage.removeItem('selectedSocCode');
    sessionStorage.removeItem('majorgroupValue');
    this.store.dispatch(new Task.SetTaskRouteId(task.id));
    if(this.userType === 'Beneficiary'){
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/task-overview`]);
    }else{
      this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/task-details/summary`]);
    }
  }

  addNewTask() {
    sessionStorage.removeItem('taskId');
    sessionStorage.removeItem('requestDataDocument');
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/new`]);
  }

  toggleMode(mode) {
    if (this.toggleStatus != mode) { this.pageIndex = 0; }
    this.toggleStatus = mode;
    this.loadBeneficiaryPetitions();
  }

  resetSearch() {
    this.searchText = ''; // reset search
    this.pageIndex = 0; // reset search
    this.payload.searchText = this.searchText;
    this.loadBeneficiaryPetitions();
  }

  searchSetUp() {
    this.searchSubscription = fromEvent(this.searchBeneficiaryListTable.nativeElement, 'keyup').pipe(
      map((event: any) => event.target.value)
      , filter(res => res.length > 2)
      , debounceTime(1000)).subscribe((text: string) => {
        this.searchText = text.trim();
        this.payload.searchText = this.searchText;
        this.loadBeneficiaryPetitions();
      });
  }

  handleDocList(task) {
    this.router.navigate([`beneficiary-landing/petitions/requested-documents/${task.id}`]);
  }

  dialogueInitializer(title: string, message: string) {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '400px',
      data: {
        update: { title, message },
        buttons: ['Cancel', 'Delete']
      }
    });
    return dialogRef;
  }

  handleDeleteSuperTask(superTaskId: number) {
    if (!superTaskId) return false;
    const title = 'Confirm';
    const message = 'Clicking Delete will delete the petition permanently from your account. You will have to create a new petition for the same beneficiary (if needed). Are you sure you want to delete this petition?';
    this.dialogueInitializer(title, message).afterClosed().subscribe(result => {
      if (result) {
        this.dashboardWidgetsService.deleteSuperTask(superTaskId).pipe(take(1)).subscribe((response: ImagilityBaseResponse) => {
          if (response?.status === 204) {
            this.toastr.success(response.message, 'Success');
            this.loadBeneficiaryPetitions();
          } else if (response?.status === 200) {
            CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
          }
        });
      }
    });
  }

  ngAfterViewInit() {
    this.translet();    
  }
  translet(){
    setTimeout(() => {
      this.referenceLibraryService.transletConversion();
    }, 600);  
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe();
  }

}// class ends


